import { fmtDate, todayLocal } from "../pnl/format";

export const PROJECT_STATUS = {
  active: { label: "Activ", cls: "bg-emerald-50 text-emerald-700 ring-emerald-600/20", dot: "bg-emerald-500" },
  in_progress: { label: "În desfășurare", cls: "bg-blue-50 text-blue-700 ring-blue-600/20", dot: "bg-blue-500" },
  planning: { label: "Planificare", cls: "bg-amber-50 text-amber-700 ring-amber-600/20", dot: "bg-amber-500" },
  completed: { label: "Finalizat", cls: "bg-slate-100 text-slate-600 ring-slate-500/20", dot: "bg-slate-400" },
};
export const statusInfo = (s) => PROJECT_STATUS[s] || { label: s || "—", cls: "bg-slate-100 text-slate-600 ring-slate-500/20", dot: "bg-slate-400" };

export const initials = (name) => (name || "?").split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

const PALETTE = ["#3d68b1", "#0d9488", "#9333ea", "#db2777", "#ea580c", "#0891b2", "#65a30d", "#4f46e5"];
export const avatarColor = (id) => PALETTE[[...(id || "")].reduce((s, c) => s + c.charCodeAt(0), 0) % PALETTE.length];

function monthBounds() {
  const t = todayLocal();
  const [y, m] = t.split("-").map(Number);
  const last = new Date(y, m, 0).getDate();
  return [`${t.slice(0, 7)}-01`, `${t.slice(0, 7)}-${String(last).padStart(2, "0")}`];
}

// procentul maxim activ în luna curentă pentru o alocare
export function monthPct(a) {
  const [ms, me] = monthBounds();
  const overlaps = (s, e) => (!s || s <= me) && (!e || e >= ms);
  if (a.allocation_periods?.length) {
    return Math.max(0, ...a.allocation_periods.filter((p) => overlaps(p.start_date, p.end_date)).map((p) => +p.pct || 0));
  }
  if (a.permanent) return +a.allocated_hours || 0;
  return overlaps(a.start_date, a.end_date) ? +a.allocated_hours || 0 : 0;
}

export function loadByEmployee(assignments) {
  const m = {};
  for (const a of assignments) m[a.employee_id] = (m[a.employee_id] || 0) + monthPct(a);
  return m;
}

export const allocSummary = (periods) => (periods || []).map((p) => `${fmtDate(p.start_date)}–${fmtDate(p.end_date)}: ${p.pct}%`);

export function periodLabel(a) {
  if (a.allocation_periods?.length) return `${a.allocation_periods.length} perioade`;
  if (a.permanent) return "Permanent";
  if (a.start_date || a.end_date) return `${fmtDate(a.start_date)} → ${fmtDate(a.end_date)}`;
  return "Pe durata proiectului";
}
